import { useContext } from 'react';
import { storesContext } from 'stores';

// wrapper for importing mobx stores. Makes it easier to mock for testing
export default function useMobxStores() {
  return useContext(storesContext);
}
